import { Link, useNavigate, Outlet, useLocation, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  if (loading) return <div className="p-10 text-[var(--rciq-muted)]">Loading…</div>;
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;

  const navItems = [
    { to: "/admin", label: "Articles", testid: "admin-nav-articles" },
    { to: "/admin/new", label: "Write New", testid: "admin-nav-new" },
    { to: "/admin/subscribers", label: "Subscribers", testid: "admin-nav-subscribers" },
  ];

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[var(--rciq-bg-tint)]" data-testid="admin-layout">
      <header className="bg-[var(--rciq-navy)] text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
          <Link to="/admin" className="flex flex-col leading-tight">
            <span className="font-serif-display text-xl font-700">Revenue Cycle IQ</span>
            <span className="text-[9px] tracking-[0.22em] uppercase text-[var(--rciq-teal)] font-700">Admin</span>
          </Link>
          <nav className="hidden md:flex items-center gap-2">
            {navItems.map((it) => {
              const active = location.pathname === it.to || (it.to !== "/admin" && location.pathname.startsWith(it.to));
              const adminActive = it.to === "/admin" && location.pathname === "/admin";
              return (
                <Link
                  key={it.to}
                  to={it.to}
                  data-testid={it.testid}
                  className={`text-xs uppercase tracking-[0.12em] font-700 px-4 py-2 rounded-full transition ${
                    (active || adminActive) ? "bg-[var(--rciq-teal)] text-[var(--rciq-navy)]" : "text-white/70 hover:text-white"
                  }`}
                >
                  {it.label}
                </Link>
              );
            })}
          </nav>
          <div className="flex items-center gap-3">
            <Link to="/" target="_blank" className="text-xs text-white/70 hover:text-[var(--rciq-teal)]" data-testid="admin-view-site">View Site ↗</Link>
            <button onClick={handleLogout} className="text-xs text-white/70 hover:text-white" data-testid="admin-logout">
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-6 lg:px-10 py-10">
        <Outlet />
      </main>
    </div>
  );
}
